module.exports = "<div *ngIf=\"message\" class=\"m-alert m-alert--outline alert alert-{{message.type}} alert-dismissible\" role=\"alert\">\n\t<button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\" (click)=\"closeAlert()\"></button>\n\t<span>{{message.text}}</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/authentication/_directives/alert.component.html
// module id = ./src/app/pages/authentication/_directives/alert.component.html
// module chunks = main